package one.healthium.settings.di

import one.healthium.settings.data.AppSettingsMenuRepository
import one.healthium.settings.data.api.SettingsApiClient
import one.healthium.settings.domain.SettingsMenuRepository
import one.healthium.settings.ui.meal_plan.MealPlanSettingsViewModel
import one.healthium.settings.ui.menu.SettingsMenuViewModel
import one.healthium.settings.ui.settings.SettingsViewModel
import org.koin.core.module.dsl.singleOf
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.bind
import org.koin.dsl.module

val settingsModule = module {
    singleOf(::AppSettingsMenuRepository) bind SettingsMenuRepository::class
    single { SettingsApiClient.factory(SettingsApiClient.createBaseHttpClient(get()), get()) }

    viewModelOf(::SettingsMenuViewModel)
    viewModelOf(::MealPlanSettingsViewModel)
    viewModelOf(::SettingsViewModel)
}